module.exports = "<div class=\"py-2\">\r\n  <cco-spinner [name]=\"spinnerName\"></cco-spinner>\r\n  <cco-progress-stage-bar\r\n    *ngIf=\"progressStageDetails\"\r\n    [stages]=\"progressStageDetails.stages\"\r\n    [currentStageValue]=\"progressStageDetails.currentStage.value\"\r\n    [currentStageLabel]=\"progressStageDetails.currentStage.label\">\r\n  </cco-progress-stage-bar>\r\n  {{ currentPosition }}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/claim/claim-present-position/claim-present-position.component.html
// module id = ../../../../../src/app/claim/claim-present-position/claim-present-position.component.html
// module chunks = main